// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survivor-leaderboard-username-column {
  color: #002129;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  max-width: 200px;
  position: sticky;
  left: 0;
  z-index: 10;
}

/* Adjust for mobile (max-width: 900px or whatever breakpoint you're using) */
@media (max-width: 768px) {
  .survivor-leaderboard-username-column {
    width: 160px;
    max-width: 160px;
  }
}
.survivor-leaderboard-username-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
}
@media (max-width: 768px) {
  .survivor-leaderboard-username-text {
    font-size: 12px !important;
  }
}

.survivor-leaderboard-second-row-text {
  font-size: 16px !important;
  font-weight: 500 !important;
  text-align: left;
}
@media (max-width: 768px) {
  .survivor-leaderboard-second-row-text {
    font-size: 12px !important;
  }
}

.survivor-leaderboard-pick-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  overflow: hidden;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .survivor-leaderboard-pick-box {
    width: 32px;
    height: 32px;
  }
}

.survivor-leaderboard-table-header {
  width: 200px;
  max-width: 200px;
  min-width: 200px;
  color: #FFC60A !important;
  font-size: 22px !important;
  font-weight: 700 !important;
  text-decoration: underline;
  text-align: left;
  position: sticky;
  left: 0;
  background-color: #002129;
  z-index: 10;
  cursor: pointer;
}
@media (max-width: 768px) {
  .survivor-leaderboard-table-header {
    width: 160px;
    max-width: 160px;
    min-width: 160px;
    font-size: 14px !important;
  }
}

.survivor-leaderboard-table-interval-columns {
  min-width: 58px;
  max-width: 58px;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: center !important;
  padding: 0 !important;
}
@media (max-width: 768px) {
  .survivor-leaderboard-table-interval-columns {
    min-width: 48px;
    max-width: 48px;
    width: 48px;
    font-size: 14px !important;
  }
}

.survivor-leaderboard-close-icon {
  color: #CC293C;
  width: 24px;
  height: 24px;
}
@media (max-width: 768px) {
  .survivor-leaderboard-close-icon {
    width: 18px;
    height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SurvivorGames/SurvivorLeaderboard/SurvivorLeaderboard.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,WAAA;AACJ;;AAEA,6EAAA;AACA;EACI;IACI,YAAA;IACA,gBAAA;EACN;AACF;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAAJ;AAEI;EAPJ;IAQQ,0BAAA;EACN;AACF;;AAGA;EACI,0BAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;AAEI;EALJ;IAMQ,0BAAA;EACN;AACF;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AACJ;AACI;EATJ;IAUQ,WAAA;IACA,YAAA;EAEN;AACF;;AACA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAEJ;AAAI;EAfJ;IAgBQ,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,0BAAA;EAGN;AACF;;AAAA;EACI,eAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,qBAAA;AAGJ;AADI;EATJ;IAUQ,eAAA;IACA,eAAA;IACA,WAAA;IACA,0BAAA;EAIN;AACF;;AADA;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAIJ;AAFI;EALJ;IAMQ,WAAA;IACA,YAAA;EAKN;AACF","sourcesContent":[".survivor-leaderboard-username-column {\n    color: #002129;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 200px;\n    max-width: 200px;\n    position: sticky;\n    left: 0;\n    z-index: 10;\n}\n\n/* Adjust for mobile (max-width: 900px or whatever breakpoint you're using) */\n@media (max-width: 768px) {\n    .survivor-leaderboard-username-column {\n        width: 160px;\n        max-width: 160px;\n    }\n}\n\n.survivor-leaderboard-username-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    text-align: left;\n    text-decoration: underline;\n    cursor: pointer;\n\n    @media (max-width: 768px) {\n        font-size: 12px!important;\n    }\n    \n}\n\n.survivor-leaderboard-second-row-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    text-align: left;\n\n    @media (max-width: 768px) {\n        font-size: 12px!important;\n    }\n}\n\n.survivor-leaderboard-pick-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    overflow: hidden;\n    margin: 0 auto;\n\n    @media (max-width: 768px) {\n        width: 32px;\n        height: 32px;\n    }\n}\n\n.survivor-leaderboard-table-header {\n    width: 200px;\n    max-width: 200px;\n    min-width: 200px;\n    color: #FFC60A !important;\n    font-size: 22px !important;\n    font-weight: 700 !important;\n    text-decoration: underline;\n    text-align: left;\n    position: sticky;\n    left: 0;\n    background-color: #002129;\n    z-index: 10;\n    cursor: pointer;\n\n    @media (max-width: 768px) {\n        width: 160px;\n        max-width: 160px;\n        min-width: 160px;\n        font-size: 14px !important;\n    }\n}\n\n.survivor-leaderboard-table-interval-columns {\n    min-width: 58px;\n    max-width: 58px;\n    color: #fff !important;\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    text-align: center !important;\n    padding: 0 !important;\n\n    @media (max-width: 768px) {\n        min-width: 48px;\n        max-width: 48px;\n        width: 48px;\n        font-size: 14px !important;\n    }\n}\n\n.survivor-leaderboard-close-icon {\n    color: #CC293C;\n    width: 24px ;\n    height: 24px;\n\n    @media (max-width: 768px) {\n        width: 18px;\n        height: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
